export const moduleActionTypes = {
  SET_MODULE: "SET_MODULE",
  TOGGLE_MODULE_ACCORDION: "TOGGLE_MODULE_ACCORDION",
  // SET_CURRENT_MODULE: "SET_CURRENT_MODULE",
};
